/* eslint-disable camelcase */
import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useReportError } from '~/hooks/useReportError';
function updateRequest(params) {
    const { id, patientId, didTalk, timeSpent, reviewType, activityDate, followUpDate, glucoseSensorReview, otherType, programType } = params;
    return axios.post(`/api/report/addTime/${id}/${patientId}/${reviewType}`, {
        did_talk: didTalk,
        time_spent: timeSpent,
        activity_date: activityDate,
        follow_up: followUpDate,
        glucose_sensor_review: glucoseSensorReview,
        other_type: otherType,
        program_type: programType
    });
}
export function useAddTimeMutation() {
    const reportError = useReportError();
    const queryClient = useQueryClient();
    return useMutation(updateRequest, {
        onSuccess: () => {
            toast.success('Changes saved successfully.');
        },
        onError: (err) => {
            reportError('Error saving patients report', err);
            toast.error('We could’t save your changes. Please try again.');
        },
        onSettled: (data, error, variables) => {
            queryClient.invalidateQueries(['patient_report', variables.id]);
        },
    });
}
